/**
 * Study Mode Landing Page
 */

import {LandingLayout} from '../../components/layout/LandingLayout';
import {SEO} from '../../components/SEO';
import {StudyHero} from '../../components/study/StudyHero';
import {StudyDemo} from '../../components/study/StudyDemo';
import {StudyTestimonials} from '../../components/study/StudyTestimonials';
import {StudyFeatures} from '../../components/study/StudyFeatures';
import {StudyIntegrations} from '../../components/study/StudyIntegrations';
import {StudyPricing} from '../../components/study/StudyPricing';
import {StudyFAQ} from '../../components/study/StudyFAQ';
import {StudyCTA} from '../../components/study/StudyCTA';

export function StudyModePage() {
  return (
    <>
      <SEO
        title="VoxaPilot Study Mode - AI-Powered Study Companion"
        description="Transform your study materials with AI-powered analysis, interactive chat, and personalized learning tools. Upload notes, get instant feedback, and master any subject."
        keywords={[
          'AI study assistant',
          'study tools',
          'flashcards',
          'note organization',
          'AI tutor',
          'study companion',
          'instant marking',
          'AI marking',
          'study feedback',
          'practice questions',
        ]}
      />
      <LandingLayout>
        <StudyHero />
        <StudyDemo />
        <StudyTestimonials />
        <StudyFeatures />
        <StudyIntegrations />
        <StudyPricing />
        <StudyFAQ />
        <StudyCTA />
      </LandingLayout>
    </>
  );
}

